import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../Pages/Components/home/Header'
import Footer from '../Pages/Components/home/Footer'
import SmartAppInstall from '../../Components/SmartAppInstall'
import HeaderCornerActions from '../../Components/HeaderCornerActions'

const MyLayout = () => {
  const location = useLocation()
  const search = new URLSearchParams(location.search)
  const listingFocusMode = location.pathname === '/properties' && search.get('view') === 'cards'

  return (
    <div>
      {!listingFocusMode && <Header />}
      {!listingFocusMode && <HeaderCornerActions />}
      <Outlet />
      {!listingFocusMode && <Footer />}
      {!listingFocusMode && <SmartAppInstall />}
    </div>
  )
}

export default MyLayout
